import ContainerWrapper from "@components/BasicComponents/Wrappers/ContainerWrapper/ContainerWrapper"
import Separator from "@components/CustomTypography/Separator/Separator"
import {backgroundColor} from "@customTypes/customTypes"
import {
	AdvancedSideAssetModuleType,
	MediaGalleryModuleType,
} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKeyTypes"
import React from "react"

import GalleryImagesBox from "../GalleryPage/GalleryContainerSection/GalleryImagesBox"
import TitleSection from "../TitleSection/TitleSection"

// import styles from "./GallerySection.module.scss"

type Props = {
	data: AdvancedSideAssetModuleType
	gallery: MediaGalleryModuleType
	background?: backgroundColor
}

const GallerySection = (props: Props) => {
	return (
		<Separator backgroundColor={props.background || "#f5f5f5"} size={128}>
			<ContainerWrapper>
				<TitleSection pageData={props.data} />
				<Separator size={32} />
				<GalleryImagesBox data={props.gallery} />
			</ContainerWrapper>
		</Separator>
	)
}

export default GallerySection
